let width = window.innerWidth

if (width >= 750) {
    $("#mobile-sticky-button-id").hide();
} else {
    $("#mobile-sticky-button-id").hide();
    $(window).scroll(function() {
        if ($(window).scrollTop() > 900) {
            $("#mobile-sticky-button-id").fadeIn("slow");
        }
        else {
            $("#mobile-sticky-button-id").fadeOut("fast");
        }
    });
}
